module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-submit"
  }, [(_vm.disclaimer) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.withDisclaimerText)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-submit--wrap"
  }, [_c('button', {
    ref: "submit",
    staticClass: "form-submit--btn btn btn__medium btn__neutral",
    class: _vm.buttonClasses,
    attrs: {
      "type": "submit",
      "disabled": _vm.isPending ? true : null
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('cmp-dot-loader', {
    staticClass: "form-submit--dot-loader",
    attrs: {
      "is-active": _vm.isPending
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-submit--btn-content btn--wrap"
  }, [_c('span', {
    staticClass: "btn--text",
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  })])], 1)]), _vm._v(" "), (_vm.generalErrors.length) ? _c('div', {
    staticClass: "form-submit--general-errors"
  }, _vm._l((_vm.generalErrors), function(generalError, generalErrorIdx) {
    return _c('span', {
      staticClass: "general-error form-submit--general-error",
      domProps: {
        "textContent": _vm._s(generalError)
      }
    })
  })) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-321f5f2a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-321f5f2a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/form/form-submit/index.vue
// module id = 527
// module chunks = 7